<template>
  <v-menu  min-width='10rem' offset-y>
    <span slot="activator">
      <v-btn small :icon="!caption"flat>
        {{caption}}
        <v-icon>arrow_drop_down</v-icon>
      </v-btn>      
    </span>
    <v-list dense>
      <template v-for="action in this.actions">
      <v-divider v-if="action.divider"></v-divider>
      <v-list-tile v-else :key="action.caption()" v-show="action.isVisible()" @click="action.run()">
        <v-list-tile-title>{{ action.caption() }}</v-list-tile-title>
      </v-list-tile>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: 'v-actions-btn',
    props: {
      caption: {
        type: String,
        default: null
      },
      actions: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data: function () {
      return {
      }
    },
    created () {
    },
    computed: {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// ActionsBtn.vue?088d7b23